<script>
import {mapActions, mapState} from 'vuex';
// import Alarm from '@assets/icons/alarm.svg';

export default {
  components: {
    // Alarm 
  },
  props: {
    name: { type: String, default: "" },
    round: { type: Number, default: 0 },
    timeout: { type: Number, default: 0 },
    gameState: { type: String, default: "" },
    tableId: { type: String, default: "" },
    // eslint-disable-next-line vue/require-valid-default-prop
    data: { type: Object, default: {} },
    dealerName: { type: String, default: "" },
  },
  data() {
    return {
      isFavorite: false,
      beginBet: false,
    }
  },
  watch: {
    favorite: {
      immediate: true,
      handler(newVal) {
        // console.log('favorite', newVal, newVal.includes(this.tableId));
        this.isFavorite = newVal.includes(this.tableId);
      },
    },
    gameState: function(newVal) {
      if(newVal === 'BETTING'){
        const that = this;
        that.beginBet = true;
        setTimeout(function(){
          that.beginBet = false;
        }, 5000);
      }
    }
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapState('favorite', ['favorite']),
    classObject: function () {
      return {
        'start-off': !this.isFavorite
      }
    },
    timeleft: function() {
      var s = this.timeout + "";
      while (s.length < 2) s = "0" + s;
      return s;
    }
  },
  methods: {
    ...mapActions('favorite', ['updateFavorite']),
    addToFavorite: function(){
      this.updateFavorite({ tableId: this.tableId });
      // console.log('add to favorite:', this.tableId)
    },
  }
}
</script>

<template>
  <div>
    <div class="bar">
      <div class="bar-content">
        <div class="bar-content-info">
          <div class="start" title="Thêm vào Mục ưa thích"
            :class="classObject"
            @click="addToFavorite"
          />
          <div class="info">
            <div class="name-game"> {{ $t('tables.' + tableId) }}</div>
            <div class="code-number"> {{ round }}</div>
          </div>
        </div>
        <div class="bar-content-time">
          <span v-if="gameState === 'LOCKING'" class="noti-stop">
            {{ $t('stop_bet') }}
          </span>
          <span v-if="gameState === 'BETTING'" class="noti-stop">
            {{ $t('begin_bet') }}
          </span>
          <span v-if="gameState === 'WAITING_RESULT'" class="noti-stop">
            {{ $t('waiting_result') }}
          </span>
          <span v-if="gameState === 'RESULTING'" class="noti-stop">
            {{ $t('showing_result') }}
          </span>
          <div class="time-border">
            <!-- <Alarm /> -->
            <div class="bg-time"></div>
            <div
              v-if="gameState === 'BETTING'"
              class="productHeader-timer productHeader-text-1"
            >
              <span class="timeout"> {{ timeleft }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="beginBet === true" class="noti active" >{{ $t('please_bet') }}</div>
    <div v-if="gameState === 'LOCKING'" class="noti active" >{{ $t('stop_bet') }}</div>
    <div class="rank">
      <div class="rank-min">{{ $t('min') }}: {{ Number(data.min).toLocaleString() }}</div>
      <div class="rank-max">{{ $t('max') }}: {{ Number(data.max).toLocaleString() }}</div>
    </div>
    <div class="name-dealer">{{ dealerName }}</div>
  </div>
</template>

<style>

</style>

